/* global $ */
import "../../js/responsive/lib/libphonenumber/intlTelInput";
import "../../css/intlTelInput.css";
if (typeof window.intlTelInputUtils === "undefined") {
  $.fn.intlTelInput.loadUtils(
    "/static/js/responsive/lib/libphonenumber/utils.js"
  );
}
